import * as React from "react";

import { HeroImage } from "components/shared/StorefrontWizard/HeroImage/HeroImage";
import {
  TabbedWizardCard,
  WizardRegionType,
} from "components/shared/StorefrontWizard/TabbedWizardCard/TabbedWizardCard";
import { WizardHeroProps } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";
import { CustomTravelAdvisoryWrapper } from "components/shared/CustomerNotifications/CustomTravelAdvisory/CustomTravelAdvisoryWrapper";

export interface WizardWithHeroImageProps extends WizardHeroProps {}

export const WizardWithHeroImage: React.FC<WizardWithHeroImageProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
  heroImageFigureClassNames,
  heroImageSrc,
  wizardState,
}) => (
  <HeroImage className={heroImageFigureClassNames} src={heroImageSrc} alt="" context={context}>
    <CustomTravelAdvisoryWrapper location="AFTER_HEADER" className="customerNotificationSquare" />
    <LobQueryRouter lobs={wizardLOBs} />
    <TabbedWizardCard
      context={context}
      wizardFormChildren={wizardFormChildren}
      wizardState={wizardState}
      wrappingClassNames="all-t-padding-twelve all-x-padding-six SimpleContainer"
      tabGroupClassNames="formAlignedTabs all-x-padding-six"
      wizardFormClassNames="wizardOverHeroImage all-x-padding-six"
      trackOnChangeTab={trackOnChangeTab}
      wizardRegionType={WizardRegionType.BEX}
    />
  </HeroImage>
);
